import React from 'react';

const MOTION_PROPS = new Set([
  'initial',
  'animate',
  'exit',
  'whileInView',
  'whileHover',
  'whileTap',
  'transition',
  'variants',
  'viewport',
  'layout',
  'layoutId',
  'drag',
  'dragConstraints',
  'dragElastic',
  'dragMomentum',
]);

const cleanMotionProps = (props: Record<string, unknown>) => {
  const next: Record<string, unknown> = {};

  for (const key of Object.keys(props)) {
    if (!MOTION_PROPS.has(key)) {
      next[key] = props[key];
    }
  }

  return next;
};

const createMotionComponent = (tag: string) => {
  const Component = React.forwardRef<any, Record<string, unknown>>((props, ref) => {
    const safeProps = cleanMotionProps(props || {});
    return React.createElement(tag, { ...safeProps, ref });
  });

  Component.displayName = `LightMotion(${tag})`;
  return Component;
};

export const motion = {
  div: createMotionComponent('div'),
  h1: createMotionComponent('h1'),
  h2: createMotionComponent('h2'),
  ul: createMotionComponent('ul'),
  img: createMotionComponent('img'),
};
